<div class="bid-history-wrapper">

  <!-- {{ currentAuction | json }} -->

  @if (activeAuction.events; as bids) {
    <div class="bid-history-head">
      <span>Bid history</span>
      <button
        [class.disabled]="viewAllBids || activeAuction.events.length <= 5"
        (click)="viewAllBids = true">

        View all
      </button>
    </div>
    <div class="bid-history">
      @for (bid of bids; track bid.transactionHash; let i = $index) {
        @if (i < (viewAllBids ? activeAuction.events.length : 5)) {
          <div class="bid-item">
            <eth-address
              [address]="bid.fromAccount.id"
              [clickable]="false">
            </eth-address>
  
            <div class="bid-amount-wrapper">
              <span>
                @if ((activeAuction.punkId | starterBid) === bid.value) {
                  Auction Started
                } @else {
                  Ξ{{ bid.value | wei | number : '1.0-4' }}
                }
              </span>
              <a
                [href]="etherscanLink + '/tx/' + bid.transactionHash"
                target="_blank">
  
                <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="rgba(var(--text-color), .5)" /></svg>
              </a>
            </div>
          </div>
        }
      }
    </div>
  } @else {
    <p>This auction has no bids</p>
  }
</div>
